// Copyright 2022 the Kubeapps contributors.
// SPDX-License-Identifier: Apache-2.0

import SchemaEditorForm from "./SchemaEditorForm";

export default SchemaEditorForm;
